import React from 'react';
import solarBg from '../images/solar_park_image.png';

/**
 * Clean neutral premium background (balanced brightness):
 * - slightly muted image for a premium feel
 * - readable overlays (no green wash)
 * - subtle vignette + texture
 * - minimal cool highlights using screen blend
 */
export default function Background() {
  return (
    <div className="fixed inset-0 -z-10">
      {/* Base image (balanced) */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105 saturate-[0.82] contrast-[1.06] brightness-[0.68]"
        style={{ backgroundImage: `url(${solarBg})` }}
      />

      {/* Balanced overlay for readable UI */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/62 via-black/38 to-black/70" />

      {/* Softer vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0)_0%,rgba(0,0,0,0.38)_58%,rgba(0,0,0,0.72)_100%)]" />

      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-[0.15] bg-grid-mask" />

      {/* Minimal cool highlights (no green tint) */}
      <div className="absolute -top-44 -right-44 h-[560px] w-[560px] rounded-full bg-sky-200/7 blur-3xl mix-blend-screen" />
      <div className="absolute -bottom-64 left-1/4 h-[620px] w-[620px] rounded-full bg-indigo-200/6 blur-3xl mix-blend-screen" />
    </div>
  );
}
